import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { currentDateFormat } from '../utils';
import FTPCredentialsTable from '../components/tables/FTPCredentialsTable';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import Swal from '../messageBox/customSweetAlert';
import { FTP_AUTH_URL } from '../constant';

function FTPCredentialsList() {
  const [credentials, setCredentials] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate] = useState(new Date());

  const fetchCredentials = useCallback(async () => {
    dispatch(setLoading(true));
    try {
      const response = await axios.get(FTP_AUTH_URL);
      const root = response?.data ?? {};
      const isOk =
        root?.success === true ||
        root?.status === 200 ||
        root?.status === '200';

      if (isOk && Array.isArray(root?.data)) {
        setCredentials(root.data);
      } else {
        setCredentials([]);
      }
    } catch (error) {
      console.error('Error fetching FTP credentials:', error);
      setCredentials([]);
      Swal.fire({
        title: 'Error',
        text:
          error?.response?.data?.message ||
          error?.message ||
          'Failed to load FTP credentials.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchCredentials();
  }, [fetchCredentials]);

  return (
    <>
      <section>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">FTP Credentials List</h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section>
        <div>
          <FTPCredentialsTable
            tableData={credentials}
            setTableData={setCredentials}
            isLoading={loading}
          />
        </div>
      </section>
      {loading && <Loader />}
    </>
  );
}

export default FTPCredentialsList;
